import React, { useState, useEffect } from "react";
import logo from "../../assets/images/logo.svg";
import { Spin, Table, Space, Popconfirm, notification } from "antd";
import { BrowserRouter as Router, useHistory, Link } from "react-router-dom";
import axios from "axios";
import { Logout } from "../Login/Logout";

const Mybooks = (props) => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const columns = [
    {
      title: "Book Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Created At",
      dataIndex: "created",
      key: "created",
    },
    {
      title: "Action",
      key: "action",
      render: (record) => (
        <Space size="middle">
          <Link to={`/Book/${record.id}`}>View</Link>
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => deleteBook(record.id)}
          >
            <a>Delete</a>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const [data, setData] = useState([]);
  useEffect(() => {
    loadBooks();
  }, []);

  const deleteBook = (id) => {
    setLoading(true);
    axios({
      method: "POST",
      headers: { "Content-Type": "application/json" },
      url: `${process.env.REACT_APP_BASE_URL}mfb/rest/book/delete?id=${id}`,
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    })
      .then((res) => {
        if (res.status == 200) {
          setLoading(false);
          notification["success"]({
            message: "Deleted Successfully",
          });
          loadBooks();
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const loadBooks = () => {
    setLoading(true);
    const userID = localStorage.getItem("UserID");

    axios({
      method: "GET",
      headers: { "Content-Type": "application/json" },
      url: `${process.env.REACT_APP_BASE_URL}mfb/rest/book/books?user_id=${userID}`,
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    })
      .then((res) => {
        if (res.status == 200) {
          console.log(res.data);
          setData(res.data);
          setLoading(false);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <div>
      <header className="navbar-header">
        <div className="home-logo">
          <img src={logo} alt="" />
          <h3>My First Book</h3>
        </div>

        <div className="home-action">
          <div className="btn-group">
            <Link to="/Dashboard">
              <button className="btn btn-border"> + Create New</button>
            </Link>
            <Logout />
          </div>
        </div>
      </header>
      <div className="books-wrap">
        <h2>My Books</h2>
        <br />
        <Spin tip="Loading..." spinning={loading}>
          <Table columns={columns} dataSource={data} pagination={false} />
        </Spin>
      </div>
    </div>
  );
};

export default Mybooks;
